import React from 'react';
import {StyleSheet, View, Text, Image, ImageSourcePropType} from 'react-native';
import {colors} from 'src/assets';
import {Icon} from 'src/components';
import {UserStatus} from 'src/domains';
import {VerificationCheckIcon} from '../verification-check-icon';

type Props = {
  source?: ImageSourcePropType;
  status?: UserStatus;
  name: string;
  isVerified?: boolean;
};

export const User: React.FC<Props> = ({source, status, name, isVerified}) => {
  const avatarStyle = {
    borderRadius: 12,
    borderWidth: 1,
    ...(status === UserStatus.LOGOUT
      ? {
          borderColor: colors.chokuGray6,
        }
      : {}),
    ...(status === UserStatus.OFFERABLE
      ? {
          borderColor: colors.chokuGreen,
        }
      : {}),
    ...(status === UserStatus.ACTIVE
      ? {
          borderColor: colors.orange,
        }
      : {}),
    ...(status === UserStatus.IN_CALL
      ? {
          borderColor: colors.chokuRed,
        }
      : {}),
  };
  return (
    <View style={styles.container}>
      {source ? (
        <Image style={[styles.image, avatarStyle]} source={source} />
      ) : (
        <View style={[styles.imageEmpty, avatarStyle]}>
          <Icon name={'person'} color={colors.chokuGray5} size={12} />
        </View>
      )}
      <View style={{flex: 1, flexDirection: 'row', alignItems: 'center'}}>
        {isVerified !== undefined && (
          <View>
            <VerificationCheckIcon
              style={{marginLeft: 6}}
              color={isVerified ? colors.chokuRed : '#E3E3E3'}
            />
          </View>
        )}
        <View style={{flex: 1}}>
          <Text style={styles.text}>{name}さん</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  image: {
    width: 24,
    height: 24,
  },
  imageEmpty: {
    backgroundColor: colors.gray1,
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    marginLeft: 4,
    fontSize: 12,
    fontWeight: '600',
    lineHeight: 14,
    color: colors.chokuGray5,
  },
});
